import { createElement, Fragment } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DoorOpenGlyph = /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("path", {
  d: "M44.72 44.91l-3.54-1.21c-.56-.19-.94-.72-.94-1.32 0-.95.94-1.62 1.84-1.32l3.54 1.21c.56.19.94.72.94 1.32 0 .96-.94 1.63-1.84 1.32z"
}), /*#__PURE__*/createElement("path", {
  d: "M56.72 14.58H27.28c-.11 0-.21.01-.31.03-.02 0-.04.01-.06.02-.08.02-.17.05-.25.08-.03.01-.06.03-.09.05-.06.03-.13.07-.18.11-.01.01-.03.01-.04.02-.02.01-.03.03-.05.05-.05.04-.1.09-.14.14-.03.03-.05.06-.08.09a.99.99 0 00-.11.17c-.02.03-.04.06-.05.1-.03.07-.06.14-.08.22-.01.03-.02.06-.03.08-.02.1-.04.21-.04.32V55.1c0 .54.29 1.04.76 1.3l22.4 12.8c.23.13.49.2.74.2.26 0 .52-.07.75-.2.46-.27.75-.76.75-1.3V56.6h5.54c.83 0 1.5-.67 1.5-1.5V16.08c.01-.83-.66-1.5-1.49-1.5zm-8.54 50.75l-19.4-11.08V17.99l19.4 4.71v42.63zm7.04-11.71h-4.04v-32.1c0-.69-.47-1.29-1.15-1.46l-10.22-2.48h15.41v36.04z"
}));
const DoorOpen = createSvg({
  name: 'door-open',
  path: DoorOpenGlyph
});

export default DoorOpen;
export { DoorOpenGlyph };
